export default __webpack_public_path__ + "assets/images/f5fc9cb21cf59334432fecef1b466ba7.png";